<div class="sl done rsdone">
  <div class="content">
    <h1 class="logo">
      <img src="/assets/doctors-next/login-logo.png" alt="Logo" />
    </h1>
    <p class="txt">
      ご登録のメールアドレスへ<br class="isSp" />認証メールを送信しました。
    </p>
    <p class="txt">
      メールアドレス認証を<br class="isSp" />完了していただけますよう、<br
        class="isPc"
      />お願いいたします。
    </p>
    <div class="bnt02 mb-3">
      <a class="login-btn" [href]="baseLink + '/login/user'">ログイン</a>
    </div>
    <div class="col-md-12 col-12 text-center mb-3">
      <a
        class="to-resend"
        [href]="resendEmailLink"
        style="font-size: 16px; font-weight: normal"
        >認証メールの再送信</a
      >
    </div>
    <p class="txt02">
      Doctors
      Next<sup>®</sup>に登録すると、デジタルヘルスサービスに関わるサポートを受けることができ、チャットでのやり取りもできます。
    </p>
  </div>
</div>
